var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTakeOutDelivering = function SvgTakeOutDelivering(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 31C24.2843 31 31 24.2843 31 16C31 7.71573 24.2843 1 16 1C7.71572 1 1 7.71573 1 16C1 24.2843 7.71572 31 16 31ZM18.5388 14.3333H9.22917C8.30869 14.3333 7.5625 15.0795 7.5625 16C7.5625 16.9205 8.30869 17.6667 9.22917 17.6667H18.7476L16.4884 19.9259C15.8375 20.5768 15.8375 21.632 16.4884 22.2829C17.1392 22.9338 18.1945 22.9338 18.8454 22.2829L25.0239 16.1044L18.8452 9.92566C18.1943 9.27478 17.139 9.27478 16.4882 9.92566C15.8373 10.5765 15.8373 11.6318 16.4882 12.2827L18.5388 14.3333Z",
    fill: "currentColor"
  })));
};
export default SvgTakeOutDelivering;